import styled, { css } from 'styled-components';
import { TypographyStyles, colours, spacing } from '@storefront/lib-global';
import { ActualPrice, WasPrice } from './PriceComponents.styles';

export const PricesContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PriceRange = styled.span`
  ${TypographyStyles.Body.Medium.SemiBold}
  color: ${colours.BLACK};
`;

export const Prices = styled.div<{ $pricesStrikethrough?: boolean; $hasPromotion?: boolean }>`
  align-items: baseline;
  display: flex;
  gap: ${spacing.XXXS};
  margin: 0;
  padding: 0;
  text-align: left;

  &.visually-hidden {
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%); /* browsers in the future */
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }

  ${WasPrice} ~ ${ActualPrice}, ${WasPrice} ~ ${PriceRange} {
    color: ${({ $hasPromotion }) => ($hasPromotion ? 'inherit' : colours.DISCOUNT_RED)};
  }

  ${({ $pricesStrikethrough }) =>
    $pricesStrikethrough &&
    css`
      ${PriceRange}, ${ActualPrice} {
        text-decoration: line-through;
      }
    `}
`;
